// src/theme.ts
import { createTheme } from "@mui/material/styles";

// Criando um tema personalizado
const theme = createTheme({
  palette: {
    mode: "light", // Pode ser 'dark' ou 'light'
    primary: {
      main: "#23CA6F", // Cor principal
      light: "#45F093", // Cor mais clara
      dark: "#06A24D", // Cor mais escura
      contrastText: "#fff", // Cor do texto contrastante
    },
    secondary: {
      main: "#042E43",
      light: "#125171",
      dark: "#001D2C",
      contrastText: "#fff", // Cor do texto contrastante
    },
    background: {
      default: "#FAFAFA", // Cor de fundo geral
      paper: "#ffffff", // Cor de fundo dos elementos 'paper' (como cartões)
    },
    text: {
      primary: "#000000", // Cor do texto principal
      secondary: "#5f6368", // Cor do texto secundário
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif", // Fonte padrão
    h1: {
      fontSize: "2.5rem", // Tamanho da fonte para h1
      fontWeight: 700, // Peso da fonte para h1
    },
    h2: {
      fontSize: "2rem", // Tamanho da fonte para h2
      fontWeight: 700, // Peso da fonte para h2
    },
    body1: {
      fontSize: "1rem", // Tamanho da fonte para o texto principal
      lineHeight: 1.5, // Espaçamento entre linhas
    },
  },
});

export default theme;
